import { ServiceRequestConfig } from '~/services/createService';
import { pilot } from '~/services/serviceInstances';

type DeleteAlertsRequest = {
  alert_ids: number[];
};

export const deleteAlerts = async (
  { alert_ids }: DeleteAlertsRequest,
  options: ServiceRequestConfig = {},
) => {
  return await pilot.put('/alert/delete/', { alert_ids }, options);
};
